import React, { createContext, useCallback, useContext, useState } from 'react';
import { TaskDetailDrawer } from '@/components/project/TaskDetailDrawer';

interface TaskDrawerContextValue {
  openTask: (taskId: string, projectId: string) => void;
  close: () => void;
}

const TaskDrawerContext = createContext<TaskDrawerContextValue | null>(null);

export const TaskDrawerProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [taskId, setTaskId] = useState<string | null>(null);
  const [projectId, setProjectId] = useState<string | null>(null);

  const openTask = useCallback((id: string, pid: string) => {
    setTaskId(id);
    setProjectId(pid);
  }, []);

  const close = useCallback(() => {
    setTaskId(null);
    setProjectId(null);
  }, []);

  return (
    <TaskDrawerContext.Provider value={{ openTask, close }}>
      {children}
      <TaskDetailDrawer
        taskId={taskId}
        projectId={projectId}
        open={!!taskId}
        onOpenChange={(o) => { if (!o) close(); }}
      />
    </TaskDrawerContext.Provider>
  );
};

export const useTaskDrawer = (): TaskDrawerContextValue => {
  const ctx = useContext(TaskDrawerContext);
  if (!ctx) {
    // Safe no-op fallback so components don't crash if provider missing
    return { openTask: () => {}, close: () => {} };
  }
  return ctx;
};
